import { render, staticRenderFns } from "./initialValuation.vue?vue&type=template&id=a20684b0&scoped=true"
import script from "./initialValuation.vue?vue&type=script&lang=js"
export * from "./initialValuation.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/reportValuation/professionReportNew.css?vue&type=style&index=0&id=a20684b0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20684b0",
  null
  
)

export default component.exports